var map = {
	"./decidim/avatar-multiuser.png": 55734,
	"./decidim/brands/google.svg": 61145,
	"./decidim/cc-badge.png": 60008,
	"./decidim/decidim-logo.svg": 56340,
	"./decidim/default-avatar.svg": 33100,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 87672,
	"./decidim/icons.svg": 77383,
	"./decidim/pattern.png": 4680,
	"./decidim/placeholder.jpg": 5829,
	"./decidim/vendor/leaflet/layers-2x.png": 13864,
	"./decidim/vendor/leaflet/layers.png": 18327,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 40578,
	"./decidim/vendor/leaflet/marker-icon.png": 45769,
	"./decidim/vendor/leaflet/marker-shadow.png": 22918,
	"./decidim/vendor/social-share-button/delicious.svg": 79026,
	"./decidim/vendor/social-share-button/douban.svg": 73480,
	"./decidim/vendor/social-share-button/email.svg": 16357,
	"./decidim/vendor/social-share-button/facebook.svg": 7931,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 35189,
	"./decidim/vendor/social-share-button/google_plus.svg": 12157,
	"./decidim/vendor/social-share-button/hacker_news.svg": 39029,
	"./decidim/vendor/social-share-button/linkedin.svg": 29277,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 46670,
	"./decidim/vendor/social-share-button/pinterest.svg": 35643,
	"./decidim/vendor/social-share-button/qq.svg": 277,
	"./decidim/vendor/social-share-button/reddit.svg": 36079,
	"./decidim/vendor/social-share-button/telegram.svg": 99906,
	"./decidim/vendor/social-share-button/tumblr.svg": 22625,
	"./decidim/vendor/social-share-button/twitter.svg": 20052,
	"./decidim/vendor/social-share-button/vkontakte.svg": 14026,
	"./decidim/vendor/social-share-button/wechat.svg": 73813,
	"./decidim/vendor/social-share-button/weibo.svg": 71257,
	"./decidim/vendor/social-share-button/whatsapp.svg": 55877,
	"./decidim/vendor/social-share-button/xing.svg": 53979
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64261;